import { DateTime } from 'luxon';
import { drParam } from './drParam';
import { drWorkflow } from './workflow/drWorkflow';
import { drOptionId } from './drOption';
import { drMedia } from './drMedia';
import { Filters } from './Common';
import { TreeItem } from './TreeItem';

export class drRepository {
    RepositoryID: number;
    RepositoryGUID: string;
    StoreID: number;
    ParentID: number;
    TopParentID: number;
    ContactID: number;
    MENU1: number;
    MENU2: number;
    MENU3: number;
    MENU4: number;
    MENU5: number;
    MENU6: number;
    MENU7: number;
    MENU8: number;
    MENU9: number;
    RepositoryType: string;
    PropertyType: string;
    SubPropertyType: string;
    RelPropertyType: string;
    SubRelPropertyType: string;
    Lang: string;
    Code: string;
    NCode: number;
    Barcode: string; // Barcode
    Label: string;
    Title: string;
    MetaTitle: string;
    TitleLink: string;
    Menu: string;
    Template: string;
    Categories: string;
    CategoryIDs: string;
    SubCategoryIDs: string;
    MainCategoryID: number;
    Folder1: string;
    Folder2: string;
    Folder3: string;
    Layout: string;
    LayoutEditor: string; // sola lettura. è il modelo del relativo layout
    SubLayout: string;
    Style: string;
    SubStyle: string;
    Css: string;
    SubCss: string;
    Target: string;
    URL: string;
    LookupPage: string;
    Redirect301: string;
    Redirect302: string;
    Robots: string;
    Searching: string;
    Canonical: string;
    Description: string;
    MetaDescription: string;
    Web20: string;
    Version: number;
    Users: string;
    WebGroups: string;
    MenuVisibility: number; // 0: hidden, 1: all, 2 registered, 3: authorized
    PageVisibility: number; // 0: hidden, 1: all, 2 registered, 3: authorized
    Layouts: string;
    Keywords: string;
    MetaKeywords: string;
    Tooltip: string;
    AccessKey: string;
    Content: string;
    ContentEditor: string;
    ContentPage: string;
    ContentEncoding: string;
    Content2: string;
    ContentEditor2: string;
    ContentPage2: string;
    ContentEncoding2: string;
    MetaTag1: string;
    MetaTag2: string;
    MetaTag3: string;
    Hits: number;
    Priority: number;
    // product
    Points: number;
    Price: number;
    NicePrice: number;
    Discount: number;
    DiscountDescription: string;
    Cost: number;
    VAT: number;
    Weight: number;
    Recharge: number;
    Quantity: number;
    Disponibility: number;
    Price1: number;
    Price2: number;
    Price3: number;
    Price4: number;
    Price5: number;
    Price6: number;
    Price7: number;
    Price8: number;
    Price9: number;
    Price10: number;
    Price11: number;
    Price12: number;
    PriceLists: string;
    PriceTypes: string;
    Qty1: number;
    Qty2: number;
    Qty3: number;
    Qty4: number;
    Qty5: number;
    Qty6: number;
    Coupon1: string;
    Coupon2: string;
    //-------------------
    Location: string;
    Note: string;
    D: (DateTime | null)[];
    C: boolean[];
    T: string[];
    M: string[];
    N: number[];
    PublishingDate: DateTime | null;
    ExpiryDate: DateTime | null;
    Abstract: string;
    PublishState: number;
    ReservedData: string;
    Params: drParam[];
    QueryString: string;
    Ordering: number;
    OrderingCP: number;
    WebGroupsB2B: string;
    MenuVisibilityB2B: number; // 0: hidden, 1: all, 2 registered, 3: authorized
    PageVisibilityB2B: number; // 0: hidden, 1: all, 2 registered, 3: authorized
    BrandID: number;
    PriceList1: number;
    PriceList2: number;
    PriceList3: number;
    PriceList4: number;
    PriceList5: number;
    PriceList6: number;
    PriceList7: number;
    PriceList8: number;
    PriceList9: number;
    // obsoleti ------------------------
    ImageGallery: [];
    MediaGallery: [];
    Documents: [];
    // ---------------------------------
    Thumb: string;
    Thumb2: string;
    GED: string;
    TopFolder1: string;
    TopFolder2: string;
    TopFolder3: string;
    Created: DateTime | null;
    CreatedBy: string;
    Modified: DateTime | null;
    ModifiedBy: string;
    Deleted: DateTime | null;
    DeletedBy: string;
    HeaderEditor: string;
    FooterEditor: string;
    RepartoRT: number;
    Sezionale: string;

    // campi calcolati
    xmlWorkflow: string; // xml drWorkflow
    mediaGallery: drMedia[];
    currPropertyType: string;
    currRelPropertyType: string;
    treePath: drOptionId[] | null;
    workflow: drWorkflow | null;
    currQty1: number;
    currQty2: number;
    currQty3: number;
    currQty4: number;
    currQty5: number;
    currQty6: number;

    constructor() {
        this.RepositoryID = 0;
        this.RepositoryGUID = '';
        this.StoreID = 0;
        this.ParentID = 0;
        this.TopParentID = 0;
        this.ContactID = 0;
        this.MENU1 = 0;
        this.MENU2 = 0;
        this.MENU3 = 0;
        this.MENU4 = 0;
        this.MENU5 = 0;
        this.MENU6 = 0;
        this.MENU7 = 0;
        this.MENU8 = 0;
        this.MENU9 = 0;
        this.RepositoryType = '';
        this.PropertyType = '';
        this.SubPropertyType = '';
        this.RelPropertyType = '';
        this.SubRelPropertyType = '';
        this.Lang = '';
        this.Code = '';
        this.NCode = 0;
        this.Barcode = '';
        this.Label = '';
        this.Title = '';
        this.MetaTitle = '';
        this.TitleLink = '';
        this.Menu = '';
        this.Template = '';
        this.Categories = '';
        this.CategoryIDs = '';
        this.SubCategoryIDs = '';
        this.MainCategoryID = 0;
        this.Folder1 = '';
        this.Folder2 = '';
        this.Folder3 = '';
        this.Layout = '';
        this.LayoutEditor = '';
        this.SubLayout = '';
        this.Style = '';
        this.SubStyle = '';
        this.Css = '';
        this.SubCss = '';
        this.Target = '';
        this.URL = '';
        this.LookupPage = '';
        this.Redirect301 = '';
        this.Redirect302 = '';
        this.Robots = '';
        this.Searching = '';
        this.Canonical = '';
        this.Description = '';
        this.MetaDescription = '';
        this.Web20 = '';
        this.Version = 0;
        this.Users = '';
        this.WebGroups = '';
        this.MenuVisibility = 0; // 0: hidden, 1: all, 2 registered, 3: authorized
        this.PageVisibility = 0; // 0: hidden, 1: all, 2 registered, 3: authorized
        this.Layouts = '';
        this.Keywords = '';
        this.MetaKeywords = '';
        this.Tooltip = '';
        this.AccessKey = '';
        this.Content = '';
        this.ContentEditor = '';
        this.ContentPage = '';
        this.ContentEncoding = '';
        this.Content2 = '';
        this.ContentEditor2 = '';
        this.ContentPage2 = '';
        this.ContentEncoding2 = '';
        this.MetaTag1 = '';
        this.MetaTag2 = '';
        this.MetaTag3 = '';
        this.Hits = 0;
        this.Priority = 0;
        // product
        this.Points = 0;
        this.Price = 0;
        this.NicePrice = 0;
        this.Discount = 0;
        this.DiscountDescription = '';
        this.Cost = 0;
        this.VAT = 0;
        this.Weight = 0;
        this.Recharge = 0;
        this.Quantity = 0;
        this.Disponibility = 0;
        this.Price1 = 0;
        this.Price2 = 0;
        this.Price3 = 0;
        this.Price4 = 0;
        this.Price5 = 0;
        this.Price6 = 0;
        this.Price7 = 0;
        this.Price8 = 0;
        this.Price9 = 0;
        this.Price10 = 0;
        this.Price11 = 0;
        this.Price12 = 0;
        this.PriceLists = '';
        this.PriceTypes = '';
        this.Qty1 = 0;
        this.Qty2 = 0;
        this.Qty3 = 0;
        this.Qty4 = 0;
        this.Qty5 = 0;
        this.Qty6 = 0;
        this.Coupon1 = '';
        this.Coupon2 = '';
        //----------------------------
        this.Location = '';
        this.Note = '';
        this.M = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''];
        this.T = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''];
        this.C = [false, false, false, false, false, false, false, false, false, false, false, false,];
        this.N = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        this.D = [null, null, null, null, null, null, null, null, null, null, null, null];
        this.PublishingDate = null;
        this.ExpiryDate = null;
        this.Abstract = '';
        this.PublishState = 0;
        this.ReservedData = '';
        this.Params = [];
        this.QueryString = '';
        this.Ordering = 0;
        this.OrderingCP = 0;
        this.WebGroupsB2B = '';
        this.MenuVisibilityB2B = 0; // 0: hidden, 1: all, 2 registered, 3: authorized
        this.PageVisibilityB2B = 0; // 0: hidden, 1: all, 2 registered, 3: authorized
        this.BrandID = 0;
        this.PriceList1 = 0;
        this.PriceList2 = 0;
        this.PriceList3 = 0;
        this.PriceList4 = 0;
        this.PriceList5 = 0;
        this.PriceList6 = 0;
        this.PriceList7 = 0;
        this.PriceList8 = 0;
        this.PriceList9 = 0;
        // obsoleti ------------------------
        this.ImageGallery = [];
        this.MediaGallery = [];
        this.Documents = [];
        // ---------------------------------
        this.Thumb = '';
        this.Thumb2 = '';
        this.GED = '';
        this.TopFolder1 = '';
        this.TopFolder2 = '';
        this.TopFolder3 = '';
        this.Created = null;
        this.CreatedBy = '';
        this.Modified = null;
        this.ModifiedBy = '';
        this.Deleted = null;
        this.DeletedBy = '';
        this.HeaderEditor = '';
        this.FooterEditor = '';
        this.RepartoRT = 0;
        this.Sezionale = '';
        
        // campi calcolati
        this.xmlWorkflow = '';
        this.mediaGallery = [];
        this.currPropertyType = '';
        this.currRelPropertyType = '';
        this.treePath = null;
        this.workflow = null;
        this.currQty1 = 0;
        this.currQty2 = 0;
        this.currQty3 = 0;
        this.currQty4 = 0;
        this.currQty5 = 0;
        this.currQty6 = 0;
    }
}

export class Image {
    url: string;
    title: string;
    folder: string;
    name: string;
    group: string;
    description: string;
    lang: string;

    constructor() {
        this.url = '';
        this.title = '';
        this.folder = '';
        this.name = '';
        this.group = '';
        this.description = '';
        this.lang = '';
    }
}

export class GetRepositoryReq {
    myToken: string;
    store: string;
    repositoryId: number;
    repositoryLabel: string;
    repositoryType: string;
    brandId: number;  // -1 pagina padre dei marchi, -2 pagina marchio
    mode: string;
    lang: string;

    constructor() {
        this.myToken = '';
        this.store = '';
        this.repositoryId = 0;
        this.repositoryLabel = '';
        this.repositoryType = '';
        this.brandId = 0;
        this.mode = 'edit';
        this.lang = '';
    }
}

export class GetRepositoryResp {
    error: string;
    repository: drRepository | null;

    constructor() {
        this.error = '';
        this.repository = null;
    }
}

export class GetRepositoryListReq {
    myToken: string;
    store: string;
    parentId: number; // se prodotto ritorna i dettagli del prodotto
    parentLabel: string;
    categoryLabel: string; // albergo ----> category
    categoryId: number;
    relatedTo: string;
    relatedId: number;
    brandId: number;  // -1 pagina padre dei marchi, -2 pagina marchio
    searchText: string;
    repositoryType: string;
    repositoryTypeFrom: string;
    orderBy: string;
    subRepositories: boolean;
    pageNum: number;
    pageSize: number;
    filters: Filters | null;
    fields: string[];

    constructor() {
        this.myToken = '';
        this.store = '';
        this.parentId = 0;
        this.parentLabel = '';
        this.categoryLabel = '';
        this.categoryId = 0;
        this.relatedTo = '';
        this.relatedId = 0;
        this.brandId = 0;
        this.searchText = '';
        this.repositoryType = '';
        this.repositoryTypeFrom = '';
        this.orderBy = '';
        this.subRepositories = false;
        this.pageNum = 1;
        this.pageSize = 25;
        this.filters = null;
        this.fields = [];
    }
}

export class GetRepositoryListResp {
    error: string;
    repositories: drRepository[];

    constructor() {
        this.error = '';
        this.repositories = [];
    }
}

export class GetProductsListReq {
    myToken: string;
    store: string;
    pageNum: number;
    pageSize: number;
    category: string;
    categoryId: number;
    relatedTo: number;

    constructor() {
        this.myToken = '';
        this.store = '';
        this.pageNum = 0;
        this.pageSize = 0;
        this.category = '';
        this.categoryId = 0;
        this.relatedTo = 0;
    }
}

export class SetRepositoryReq {
    myToken: string;
    repository: drRepository | null;
    gridConfig: string;  // Code
    addToCat: string;  // albergo
    parentLabel: string;
    parentId: number;

    constructor() {
        this.myToken = '';
        this.repository = null;
        this.gridConfig = '';
        this.addToCat = '';
        this.parentLabel = '';
        this.parentId = 0;
    }
}

export class SetRepositoryResp {
    error: string;
    debug: string;
    repository: drRepository | null;

    constructor() {
        this.error = '';
        this.repository = null;
        this.debug = '';
    }
}

export class NewRepositoryReq {
    myToken: string;
    repositoryType: string; // WebPage, Category, Product
    title: string; // <it>Titolo</it><en>Title</en>
    parentId: number;
    categoryId: number; // quando si crea un prodotto
    brandId: number;

    constructor() {
        this.myToken = '';
        this.repositoryType = '';
        this.title = '';
        this.parentId = 0;
        this.categoryId = 0;
        this.brandId = 0;
    }
}

export class DelRepositoryReq {
    myToken: string;
    repositoryId: number;

    constructor() {
        this.myToken = '';
        this.repositoryId = 0;
    }
}

export class NewRepositoryResp {
    error: string;
    node: TreeItem | null;

    constructor() {
        this.error = '';
        this.node = null;
    }
}

export class PasteRepositoryReq {
    myToken: string;
    sourceRepositoryId: number; // copyRepositoryId
    sourceRepositoryType: string; // sourceRepositoryType
    destRepositoryId: number; // pasteRepositoryId
    destRepositoryType: string;
    withChild: boolean;
    mode: string; // cut or copy
    ids: number[];

    constructor() {
        this.myToken = '';
        this.sourceRepositoryId = 0;
        this.sourceRepositoryType = '';
        this.destRepositoryId = 0;
        this.destRepositoryType = '';
        this.withChild = false;
        this.mode = '';
        this.ids = [];
    }
}

export class GetRepositoryGridReq {
    myToken: string;
    store: string;
    searchText: string;
    filterBy: string;
    gridConfig: string;
    pageNum: number;
    pageSize: number;
    repositoryType: string;
    parentId: number;
    parentLabel: string;
    categoryId: number;
    categoryLabel: string;
    brandId: number;  // -1 pagina padre dei marchi, -2 pagina marchio
    subRepositories: boolean;
    options: drRepository | null;
    fields: string[];

    constructor() {
        this.myToken = '';
        this.store = '';
        this.searchText = '';
        this.filterBy = '';
        this.gridConfig = '';
        this.pageNum = 0;
        this.pageSize = 100;
        this.repositoryType = '';
        this.parentId = 0;
        this.parentLabel = '';
        this.categoryId = 0;
        this.categoryLabel = '';
        this.brandId = 0;
        this.subRepositories = false;
        this.options = null;
        this.fields = [];
    }
}

export class GetRepositoryGridResp {
    error: string;
    repositories: drRepository[]; // es. 100 record max
    numPages: number; // es 5 pagine
    numRepositories: number; // es 480 -> num repository totali che rispettano il filtro searchText
    numAll: number; // es 1000 -> tutti i repository in assoluto

    constructor() {
        this.error = '';
        this.repositories = [];
        this.numPages = 0;
        this.numRepositories = 0;
        this.numAll = 0;
    }
}

export class SelectRepositoryReq {
    myToken: string;
    repositoryId: number;
    select: boolean;

    constructor() {
        this.myToken = '';
        this.repositoryId = 0;
        this.select = false;
    }
}

export class SelectRepositoryResp {
    error: string;
    numSelected: number;

    constructor() {
        this.error = '';
        this.numSelected = 0;
    }
}
